import { render } from "./customAddressConfirm.vue?vue&type=template&id=2ef08b6f&scoped=true&lang=pug"
import script from "./customAddressConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./customAddressConfirm.vue?vue&type=script&setup=true&lang=js"

import "./customAddressConfirm.vue?vue&type=style&index=0&id=2ef08b6f&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/cross-bridge v0.1.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef08b6f"]])

export default __exports__